<template>
  <div
    class="news-item"
    @click="
      $router.push({
        name: 'NewsShow',
        params: { id: item.id },
        query: { recommend: $route.params.id, title: $route.query.title },
      })
    "
  >
    <div class="cover-wrap">
      <img class="cover" :src="item.thumb_img" />
    </div>
    <div class="right">
      <div class="news-title">{{ item.title }}</div>
      <div class="news-description">{{ item.description }}</div>
      <div class="news-footer">
        <span>{{ item.created_at | tsFormat('yyyy/MM/dd hh:mm') }}</span>
        <span class="click-rate">{{ item.click_rate }}次浏览</span>
      </div>
    </div>
    <div class="arrow"></div>
  </div>
</template>
<script>
export default {
  name: 'NewsRecommendItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.news-item {
  height: 210px;
  background: white;
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 36px;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);

    .arrow {
      background-color: $primary-color;
      border-color: $primary-color;
      background-image: url('~@/assets/images/news/arrow-white@2x.png');
    }

    .cover {
      transform: scale(1.1);
    }

    .news-description,
    .news-title {
      top: -4px;
    }
    .news-footer {
      top: 4px;
    }
  }

  .right {
    width: 650px;
  }

  .cover-wrap {
    width: 315px;
    height: 100%;
    margin-right: 48px;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 5px;
  }

  .cover {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    transform: scale(1);
    transition: 0.2s all;
  }

  .news-title {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 18px;
    position: relative;
    top: 0;
    transition: 0.2s all;
  }

  .news-description {
    margin-bottom: 24px;
    height: 48px;
    font-size: 16px;
    color: rgba(140, 140, 140, 1);
    line-height: 24px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    position: relative;
    top: 0;
    transition: 0.2s all;
  }

  .news-footer {
    font-size: 14px;
    color: #999999;
    line-height: 1;
    position: relative;
    top: 0;
    transition: 0.2s all;

    .click-rate {
      margin-left: 14px;
    }
  }

  .arrow {
    width: 54px;
    height: 54px;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 3px;
    box-sizing: border-box;
    margin: 0 67px 0 61px;
    background-image: url('~@/assets/images/news/arrow-gray@2x.png');
    background-size: 20px 16px;
    background-repeat: no-repeat;
    background-position: center center;
    flex-shrink: 0;
  }
}
</style>
